<template>
    <v-app>
        <v-toolbar dense max-height="50px">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="green--text"></v-app-bar-nav-icon>
            <v-toolbar-title class="green--text">iSee</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="green">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <v-btn icon color="green">
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card height="100%" class="overflow-hidden">
            <v-navigation-drawer
                    v-model="drawer"
                    absolute
                    temporary
                    bottom
            >
                <v-list-item>
                    <v-list-item-avatar>
                        <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>Ali</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list dense>

                    <v-list-item
                            v-for="item in menuItems"
                            :key="item.title"
                            link
                            :to="item.route"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>
                                    {{ item.title }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
            <v-container>
                <router-view/>
            </v-container>
        </v-card>
        <v-footer padless>
            <v-col
                    class="text-center green--text font-weight-bold"
                    cols="12"
            >
                {{ new Date().getFullYear() }} — <strong>iSee</strong>
            </v-col>
        </v-footer>
    </v-app>
</template>

<script>
    export default {
        name: 'App',
        data: () => ({
            drawer: false,
            menuItems: [
                {title: 'Home', icon: 'mdi-chevron-right', route: '/'},
                {title: 'Assets', icon: 'mdi-chevron-right', route: '/assets'},
                {title: 'Programs', icon: 'mdi-chevron-right', route: '/programs'},
                {title: 'Top Domains', icon: 'mdi-chevron-right', route: '/top-domains'},
                {title: 'Servers', icon: 'mdi-chevron-right', route: '/servers'},
            ],
        }),
    };
</script>
